import Backbone from 'backbone'
import template from 'scoreboard/components/current-user-tooltip-view.hbs'
import scoreboardUrl from 'scoreboard/components/scoreboard-url'
import user from 'scoreboard/components/user'
import appDisplay from 'scoreboard/components/app-display'
import EditProfile from 'scoreboard/admin/principals/users/edit-profile'
import permissions from 'scoreboard/components/permissions'

/**
 * This view is a tooltip that allows the user to log out or edit their
 * profile. It's found by clicking on the user avatar in the top right
 * of the top-pane bar on every page.
 */

const CurrentUserTooltipView = Backbone.View.extend({

	events: {
		'click .open-edit-profile': 'onClickOpenEditProfile',
		'click .logout': 'onClickLogout'
	},

	render: function() {
		this.$el.empty().append(template(this.context()))
		return this
	},

	context: function () {
		let profileEditable = permissions.personalAccountInfo()
		let icon = profileEditable ? 'edit-flat' : 'user-avatar'
		let label = profileEditable ?
			'common.user.currentUser.editProfile' :
			'common.user.currentUser.viewProfile'
		return {
			icon,
			label
		}
	},

	onClickOpenEditProfile: function() {
		appDisplay.dialog(new EditProfile({ model: user.model }))
	},

	onClickLogout: function() {
		location.href = scoreboardUrl('logout')
	}

})

export default CurrentUserTooltipView

CurrentUserTooltipView.__filename__ = 'components/current-user-tooltip-view.js'
